import { Grid, Typography, useTheme } from "@mui/material";

const Title2Component = ({title, description, needWhite=false}) => {
    const theme = useTheme();

    return (
        <>
            <Grid
                direction='row'
                justifyContent='start'
                alignItems='end'
                container
                sx={{
                    width: '100%',
                    pb: {xs: 2, md: 5}
                }}
                spacing={{xs: 1, md: 2}}
            >
                {/* Title */}
                <Grid size={12}>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: {xs: 45, md: 60, lg: 75},
                            color: !needWhite ? theme.palette.primary.main : 'white',
                            lineHeight: 1.15,
                            textAlign: 'center',
                        }}
                        data-aos="fade-up"
                        data-aos-duration="1000"
                    >
                        {title}
                    </Typography>
                </Grid>

                {/* Description */}
                <Grid size={12}>
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: {xs: 12, md: 14, lg: 16},
                            textAlign: 'center',
                            color: !needWhite ? 'black' : 'white'
                        }}
                        data-aos="fade-up"
                        data-aos-delay="100"
                        data-aos-duration="1000"
                    >
                        {description}
                    </Typography>
                </Grid>
            </Grid>
        </>
    );
}

export default Title2Component;